/**
 * Does nothing but return the supplied value
 *
 * @param val
 */
export const identity = <T>(val: T) => val;
